import Content from '../types/enums/content';
import Event from './event';
import { IIACornerEventRequest } from '../types/interfaces/event';

class Backdoor extends Event {
  constructor(request: IIACornerEventRequest) {
    super({ ...request, type: Content.BACK_DOOR });
  }
}

export default Backdoor;
